import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { money } from './CashFlowChart';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Tile = ({ label, value, late, lateLabel, to }) => (
  <Link to={to} className="block px-4 py-3 hover:bg-surface-50 dark:hover:bg-surface-800">
    <p className="text-xs text-surface-500 dark:text-surface-400">{label}</p>
    <p className={`text-xl font-semibold tabular-nums ${value < 0 ? 'text-red-600 dark:text-red-400' : 'text-surface-900 dark:text-surface-50'}`}>{money(value)}</p>
    {late > 0 && <p className="text-xs text-red-600 dark:text-red-400 tabular-nums">{lateLabel}</p>}
  </Link>
);

/**
 * The home page's short version of Güncel Durum: what is to collect and to
 * pay (with the overdue part), the money in the bank and the cash, and the
 * balance 12 weeks from now. The details live on the Ön Muhasebe page.
 */
const CurrentStatusSummary = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/accounting/current-status`).then(({ data: d }) => setData(d)).catch(() => setData(null));
  }, []);

  if (!data?.summary || !data.forecast) return null;
  const S = (k, o) => t(`accounting.status.short.${k}`, o);
  const { in: inn, out } = data.summary;
  return (
    <section className="card p-0 overflow-hidden" data-testid="current-status-summary">
      <div className="flex items-baseline justify-between px-4 pt-3">
        <h2 className="section-title text-base">{t('accounting.status.title')}</h2>
        <Link to="/modules/accounting" className="text-xs text-primary-600 dark:text-primary-400 hover:underline">{S('details')}</Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-surface-100 dark:divide-surface-800">
        <Tile label={S('toCollect')} value={inn.total} late={inn.overdue} lateLabel={S('late', { amount: money(inn.overdue) })}
          to="/modules/accounting" />
        <Tile label={S('toPay')} value={out.total} late={out.overdue} lateLabel={S('late', { amount: money(out.overdue) })}
          to="/modules/accounting" />
        <Tile label={S('cash')} value={data.cash} to="/modules/accounting/bank-cash" />
        <Tile label={S('in12Weeks')} value={data.forecast.closing} to="/modules/finance/cash-flow" />
      </div>
    </section>
  );
};

export default CurrentStatusSummary;
